import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Button from "@mui/material/Button";
import type { SxProps } from "@mui/material/styles";

type FilterDropDownButtonProps = {
  open?: null | Boolean;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  label: string;
  sx?: SxProps;
};

export default function FilterDropDownButton({
  label,
  open,
  sx,
  handleClick
}: FilterDropDownButtonProps) {
  return (
    <Button
      id="filter-dropdown-button"
      aria-controls={open ? "filter-menu" : undefined}
      aria-haspopup="true"
      aria-expanded={open ? "true" : undefined}
      variant="contained"
      disableElevation
      onClick={handleClick}
      endIcon={<KeyboardArrowDownIcon />}
      sx={{
        "&.MuiButton-containedSizeMedium": {
          padding: "5px 15px "
        },
        ...sx
      }}
    >
      {label}
    </Button>
  );
}
